import * as React from "react";
export class TeamName extends React.PureComponent {
    render() {
        const classname = this.props.isServing ? `${this.props.clsName} ${this.props.clsName}--isServing` : this.props.clsName;
        return (React.createElement("div", { className: classname }, this.props.teamName));
    }
}
//# sourceMappingURL=TeamName.js.map